package org.hs_soft.runmynesto.domain.model.home.user.single_user


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class SingleUserModel(
    @SerialName("data")
    val data: Data,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)

@Serializable
data class Data(
    val cashAssist: CashAssist
)

@Serializable
data class CashAssist(
    val getUser: GetUser
)

@Serializable
data class GetUser(
    val id: String,
    val isActive: Boolean?=null,
    val name: String?=null,
    val printName: String?=null,
    val shortName:String?=null,
    val password: String ?=null,
    val isTimeTracking:Boolean?=null,
    val isDayFinStatements:Boolean?=null,
    val isAdmin:Boolean?=null,
    val isManager:Boolean?=null,
    val isViewSales:Boolean?=null,
    val isFinStatements:Boolean?=null,
    val waiterKey:String?=null,
    val cancelationPermissions:String?=null,
    val img: Img?=null,
    val cashRegisterId:List<String> ?=null,
)

@Serializable
data class Img(
    val url: String ?=null
)